export const base64ToArrayBuffer = (base64: string): ArrayBufferLike => {
	const binary_string = window.atob(base64);
	const len = binary_string.length;
	const bytes = new Uint8Array(len);
	for (let i = 0; i < len; i++) {
		bytes[i] = binary_string.charCodeAt(i);
	}
	return bytes.buffer;
};

export const base64FileToBlob = (file: string) => {
	const buff = base64ToArrayBuffer(file);
	const blob = new Blob([buff]);
	return blob;
};
